import { _ } from "../../../polyglot/polyglot.js";
import { makeDropdown } from "../../makeRoadmapStepContent.js";
import AbstractRoadmapStep from "../../AbstractRoadmapStep.js";

/**
 * This allows the user to choose accounts for incoming, outgoing and
 * net VAT.
 */
export default class ForecastVatStep extends AbstractRoadmapStep {
	getTitle() {
		return _("Forecast VAT");
	}

	_getSubtitle() {
		return _(
			"Forecasted income and costs will effect the VAT accounts in forecasted periods. In order to predict the movement of VAT, please select the VAT accounts to be used.",
		);
	}

	_doSubmit({ onDone }) {
		const incomingVATAccount = this._context.configuration.getIncomingVat();
		const outgoingVATAccount = this._context.configuration.getOutgoingVat();
		const netVATAccount = this._context.configuration.getVatSumAccount();

		if (!incomingVATAccount) {
			this.addSubmitError(_("An input VAT account must be selected"));
		}
		if (!outgoingVATAccount) {
			this.addSubmitError(_("An output VAT account must be selected"));
		}
		if (!netVATAccount) {
			this.addSubmitError(_("A net VAT account must be selected"));
		}

		onDone();
	}

	_getStepContent() {
		return [
			this._makeIncomingVatAccountDropdown(),
			this._makeOutgoingVatAccountDropdown(),
			this._makeNetVatAccountDropdown(),
		];
	}

	_makeIncomingVatAccountDropdown() {
		const incomingVATAccount = this._context.configuration.getIncomingVat();

		return makeDropdown({
			title: _("Main input VAT account"),
			helpText: _(
				"Choose which account you want your forecasted revenue to record VAT to. It is possible to the same account to all 3 of these.",
			),
			dataTestName: "income-vat",
			noDefaultSelection: true,
			noSelectionText: "",
			items: this._makeDropdownItemsFromAccounts({
				selectedAccount: incomingVATAccount,
			}),
			onChange: (selection) =>
				this._context.configuration.setIncomingVat(
					selection?.id.toString(),
				),
		});
	}

	_makeOutgoingVatAccountDropdown() {
		const outgoingVATAccount = this._context.configuration.getOutgoingVat();

		return makeDropdown({
			title: _("Main output VAT account"),
			helpText: _(
				"Choose which account you want your forecasted costs to record VAT to. It is possible to the same account to all 3 of these.",
			),
			dataTestName: "outgoing-vat",
			noDefaultSelection: true,
			noSelectionText: "",
			items: this._makeDropdownItemsFromAccounts({
				selectedAccount: outgoingVATAccount,
			}),
			onChange: (selection) =>
				this._context.configuration.setOutgoingVat(
					selection?.id.toString(),
				),
		});
	}

	_makeNetVatAccountDropdown() {
		const netVATAccount = this._context.configuration.getVatSumAccount();

		return makeDropdown({
			title: _("Main net VAT account"),
			helpText: _(
				"Choose where you want to include VAT debt to. It is possible to the same account to all 3 of these",
			),
			dataTestName: "net-vat",
			noDefaultSelection: true,
			noSelectionText: "",
			items: this._makeDropdownItemsFromAccounts({
				selectedAccount: netVATAccount,
			}),
			onChange: (selection) =>
				this._context.configuration.setVatSumAccount(
					selection?.id.toString(),
				),
		});
	}

	_makeDropdownItemsFromAccounts({ selectedAccount: vatAccount }) {
		return this._context.getAccountDropdownItems({
			selectedFn: (account) => vatAccount === account.getNumber(),
		});
	}
}
